import pLimit from "p-limit";

export type PromiseRunnerType = "PARALLEL" | "SERIAL"

export interface PromiseRunnerOptions {
    type: PromiseRunnerType
    parallelLimit: number
}

export const PromiseRunnerOptionsDefault: PromiseRunnerOptions = {
    type: "PARALLEL",
    parallelLimit: 5
}

export async function runPromises<T,R>(rawOptions: PromiseRunnerOptions | undefined, input: T[], fn: (input: T) => Promise<R>): Promise<R[]> {
    const options = rawOptions ?? PromiseRunnerOptionsDefault
    if(options.type === "PARALLEL") {
        const limit = pLimit(options.parallelLimit)
        return limit.map(input, fn)
    } else {
        const result: R[] = []
        for(const item of input) {
            const r = await fn(item)
            result.push(r)
        }
        return result
    }
}